import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WidgetOpen {
    isOpen: boolean;
}
const initialState: WidgetOpen = {
    isOpen: false,
};
const WidgetOpenSlice = createSlice({
    name: 'WidgetOpen',
    initialState,
    reducers: {
        setWidgetOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setWidgetOpen } = WidgetOpenSlice.actions;
export default WidgetOpenSlice.reducer;
